import type { HangmanGame } from "./types.js";

const WORDS: string[] = [
  "apple", "beach", "candy", "dance", "eagle", "flame", "grape", "honey",
  "ivory", "jelly", "koala", "lemon", "mango", "noble", "ocean", "pearl",
  "queen", "rain", "sugar", "tiger", "umbra", "vivid", "whale", "xenon",
  "yacht", "zebra", "bloom", "coral", "dawn", "ember", "frost", "glow",
  "haven", "iris", "jade", "kite", "lune", "mist", "nova", "opal",
  "rocket", "planet", "guitar", "silver", "golden", "winter", "summer",
  "jungle", "desert", "forest", "river", "mountain", "valley",
  "castle", "knight", "dragon", "magic", "sword", "shield", "crown",
  "throne", "royal", "jester",
  "bridge", "tunnel", "garden", "window", "lantern", "candle",
  "mirror", "copper", "bronze", "steel",
];

export function pickWord(): string {
  return WORDS[Math.floor(Math.random() * WORDS.length)];
}

const MAX_WRONG: Record<string, number> = { easy: 10, medium: 8, hard: 6 };

export function createGame(difficulty: string = "medium"): HangmanGame {
  const w = pickWord();
  return {
    word: w,
    display: w.split("").map(() => "_"),
    guessed: [],
    wrongGuesses: 0,
    maxWrong: MAX_WRONG[difficulty] || 8,
    winner: null,
  };
}

export function guess(game: HangmanGame, letter: string): HangmanGame {
  if (game.winner) return game;
  const l = letter.toLowerCase();
  if (game.guessed.includes(l)) return game;
  if (l.length !== 1 || !/[a-z]/.test(l)) return game;

  const guessed = [...game.guessed, l];
  let { display, wrongGuesses } = game;

  if (game.word.includes(l)) {
    display = game.word.split("").map((ch, i) => guessed.includes(ch) ? ch : "_");
  } else {
    wrongGuesses += 1;
  }

  let winner: "guesser" | "picker" | null = null;
  if (wrongGuesses >= game.maxWrong) winner = "picker";
  else if (!display.includes("_")) winner = "guesser";

  return { ...game, display, guessed, wrongGuesses, winner };
}
